import { useNavigate } from 'react-router-dom';

const currentUrl = window.location.href;
let isUAEZone: boolean = false;
if (currentUrl.includes('uae')) {
  isUAEZone = true;
} else {
  isUAEZone = false;
}
function ProductNavbar() {
  const navigate = useNavigate();
  return (
    <div className="w-full bg-transparent-500 h-16 text-center flex justify-start mt-0 mb-0 max-md:mb-0 items-center border-solid border-[#98A2B3] pb-8 max-md:pb-2">
      <span
        className="lg:pl-16 md:pl-8 max-md:pl-8 lg:pt-8 md:pt-6 max-md:pt-2 cursor-pointer"
        onClick={() => {
          navigate(isUAEZone ? '/uae' : '/');
        }}
      >
        <img
          src="https://res.cloudinary.com/dx6dieevo/image/upload/f_auto,q_auto:good,w_auto/v1723727518/pixa-pie/pixa_dark_logo.svg"
          alt="Logo"
          className="h-6 md:h-8"
          style={{ objectFit: 'contain' }}
        />
      </span>
    </div>
  );
}

export default ProductNavbar;
